<template>
	<div class="data-center">
		 <Row type="flex" :gutter="16">
	        <Col span="8" order="4">
	        	<Card >
			        <div style="text-align:center;cursor: pointer;" onclick="window.open('http://www.cnpat.com.cn/')">
			            <img src="@/assets/index/data/agency/zgzl.jpg" width="100%" height="160px" >
			            <div class="agency-card">
			            	<p class="agency-title">中国专利信息中心</p>
			            	<p class="agency-body">直属：国家知识产权局</p>
			            	<p class="agency-body">成立时间：1989年</p>
			            </div>
			        </div>
			    </Card>
	        </Col>
	        <Col span="8" order="4">
	        	<Card >
			        <div style="text-align:center;cursor: pointer;"  onclick="window.open('http://www.guozhuan.com/')">
			            <img src="@/assets/index/data/agency/guozhuan.jpg" width="100%" height="160px">
			            <div class="agency-card">
			            	<p class="agency-title">北京国专知识产权有限责任公司</p>
			            	<p class="agency-body">国内外专利代缴费服务</p>
			            	<p class="agency-body">隶属于中国专利信息中心</p>
			            </div>
			        </div>
			    </Card>
	        </Col>

	        <Col span="8" order="4">
	        	<Card >
			        <div style="text-align:center;cursor: pointer;" onclick="window.open('http://www.bjidit.com/')">
			            <img src="@/assets/index/data/agency/xinfa.jpg" width="100%" height="160px" >
			            <div class="agency-card">
			            	<p class="agency-title">北京新发智信科技有限责任公司</p>
			            	<p class="agency-body">中国专利信息中心发起成立</p>
			            	<p class="agency-body">特色产品：专利之星-专利检索系统</p>
			            </div>
			        </div>
			    </Card>
	        </Col>
<!-- 	         <Col span="6" order="4">
	        	<Card >
			        <div style="text-align:center;cursor: pointer;" onclick="window.open('http://www.san-you.com/')">
			            <img src="@/assets/index/data/agency/sanyou.jpg" width="100%" height="160px" >
			            <div class="agency-card">
			            	<p class="agency-title">北京三友知识产权代理有限公司</p>

			            	<Row>
						        <Col span="12">
						        	<p class="agency-body">代理人人数：130</p>
			            			<p class="agency-body">2016授权率：81%</p>
						        </Col>
						        <Col span="12">
						        	<p class="agency-body">2017授权率：78%</p>
			            			<p class="agency-body">2015授权率：75%</p>
						        </Col>
						    </Row>
			            </div>
			        </div>
			    </Card>
	        </Col>
 -->	        <!--<Col span="6" order="4">
	        	<Card >
			        <div style="text-align:center;cursor: pointer;"  onclick="window.open('http://www.pppas.net')">
			            <img src="@/assets/index/data/agency/dlrxh.jpg" width="100%" >
			            <div class="agency-card">
			            	<p class="agency-title">全国专利代理公共服务平台</p>
			            	<p class="agency-body">主办单位：中华全国专利代理人协会</p>
			            	<p class="agency-body">技术支持：中国专利信息中心</p>
			            </div>
			        </div>
			    </Card>
	        </Col>-->
	    </Row>


	</div>

</template>

<script>
	export default {
		name: 'agencylist',
		data() {
			return {
				active: 0
			};
		}
	}
</script>

<style scoped lang="scss">
	.agency-card{
		background-color: #FAFAFA;
		padding-bottom: 15px;
	}

	.agency-title{
		line-height: 50px;
		font-size: 16px;
		font-weight: 700;

	}

	.agency-body{
		line-height: 25px;
	}

</style>



// WEBPACK FOOTER //
// src/view/index/data/agencylist.vue